<template>
  <div class="sort">
    <el-checkbox-group  v-model="result" :min="min" :max="max" :disabled="disabled" :readonly="readonly">
       <el-checkbox v-for="(item,index) in dic" :key="index" :label="item.value">
         <span class="index" v-if="result.findIndex(c=>c==item.value)!= -1">
          {{result.findIndex(c=>c==item.value)+1}}
         </span>
         {{item.label}}
        </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: "sort",
  props: {
    min: {
      type: Number,
      default: undefined
    },
    max: {
      type: Number,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dic: {
      type: Array,
      default: () => {
        return []
      }
    },
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    dataType: {
      type: String,
      default: 'array'
    },
    change: Function,
    prop: String,
    skipType: undefined,
    skipValue: String,
  },
  data () {
    return {
      result: [],
    };
  },
  watch: {
    'value': {
      handler(val) {
        if(!val) {
          this.result = []
        }else {
          this.result = val
        }
        if(this.change && typeof(this.change)=='function') this.change({value: val, column: this})
      },
    },
    'result'(val) {
      this.$emit('input', val)
    },
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
};
</script>
<style scoped>
.sort /deep/ .el-checkbox {
  margin-right: 10px;
  display: block;
}
.sort /deep/ .el-checkbox__label {
  position: relative;
}
.sort /deep/ .index {
    position: absolute;
    left: -14px;
    z-index: 99;
    width: 14px;
    height: 14px;
    line-height: 14px;
    text-align: center;
    color: #fff;
    background: #409EFF;
    top: 3px;
    font-size: 12px;
}
</style>